import { ToolPanelDef } from "ag-grid-enterprise";

export const toolPanelsDefault: ToolPanelDef[] = [
	{
		iconKey: "columns",

		id: "columns",
		labelDefault: "Columns",
		labelKey: "columns",
		toolPanel: "agColumnsToolPanel"
	},
	{
		iconKey: "filter",
		id: "filters",
		labelDefault: "Filters",
		labelKey: "filters",
		toolPanel: "agFiltersToolPanel"
	}
];

export const toolPanelsNoPivot: ToolPanelDef[] = [
	{
		iconKey: "columns",
		id: "columns",
		labelDefault: "Columns",
		labelKey: "columns",
		toolPanel: "agColumnsToolPanel",
		toolPanelParams: {
			suppressPivotMode: true,
			suppressPivots: true,
			suppressRowGroups: true,
			suppressValues: true
		}
	},
	{
		iconKey: "filter",
		id: "filters",
		labelDefault: "Filters",
		labelKey: "filters",
		toolPanel: "agFiltersToolPanel"
	}
];

// wsapi agGridRows ignores pivotMode/pivotCols, so pivot stays hidden.
export const toolPanelsGroupable: ToolPanelDef[] = [
	{
		iconKey: "columns",
		id: "columns",
		labelDefault: "Columns",
		labelKey: "columns",
		toolPanel: "agColumnsToolPanel",
		toolPanelParams: {
			suppressPivotMode: true,
			suppressPivots: true
		}
	},
	{
		iconKey: "filter",
		id: "filters",
		labelDefault: "Filters",
		labelKey: "filters",
		toolPanel: "agFiltersToolPanel"
	}
];
